import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { COLORS } from 'constants/colors'

const StyledRoot = styled(Button)(({ ownerState }) => ({
  cursor: 'pointer',
  margin: '0 auto',
  minWidth: '32px',
  ...(ownerState?.color !== 'inherit' && {
    '&.Mui-disabled': {
      background: COLORS.blueDisabled.rgba,
      color: COLORS.primaryWhite.rgba,
    },
  }),
  '&.MuiButton-text': {
    background: 'transparent',
  },
}))

const StyledButton = ({ className, color, variant, ...rest }) => (
  <StyledRoot className={classnames(className)} color={color} variant={variant} {...rest} />
)

StyledButton.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
}

StyledButton.defaultProps = {
  className: null,
  color: 'primary',
  variant: 'contained',
}

export default StyledButton
